module.exports = __webpack_public_path__ + "img/weixin.c2c39c3a.png";